// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"450b82e9","208":"e6a8df59","236":"9a3fcca4","353":"7f849db3","512":"85e2dc6e","549":"17f432ba","813":"ca4893c0"}[chunkId] + ".chunk.js";
};